module.exports = __webpack_public_path__ + "img/postback-step-4.ru.219667ad.jpg";